import React from 'react'
import $ from 'jquery';
import '../Styles/ProfessionalService.css'
import HappyClients from '../Components/HappyClients'
import BottomCarousel from '../Components/BottomCarousel'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import DomianIMg from '../assets/images/psd-img.jpg'
import Form from '../Components/form'
import NewForm from '../Components/NewForm'
// import Reload from '../assets/images/reload.png';
// import ChapchaImg from '../assets/images/captcha.png'
import LeaderForm from '../Components/LearningForm';

function ProfessionalService() {
   $(document).ready(function(){
      $('.customer_carousel2').owlCarousel({
        loop:true,
        margin:0,
        
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        nav:false,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            320:{
                items:1
            },
            480:{
                items:1
            },
            600:{
                items:1
            },
            767:{
                items:1
            },
            991:{
                items:1
            },
            1200:{
                items:2
            }
        }
    });
    });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
// Accordian Action
var action = 'click';
var speed = "500";
// Document Ready
$(document).ready(function(){
// Question handler
$('li.q').on(action, function(){
// Check if the current question is already opened
var isOpen = $(this).hasclassName('rotate');
// Reset all other questions
$('li.q').removeclassName('rotate');
$('li.a').slideUp(speed);
// Open or close the current question accordingly
if (!isOpen) {
$(this).addclassName('rotate');
$(this).next().slideDown(speed);
}
}); // End on click
}); // End Ready
return (
<div className="Apsp">
   <header className="header">
      <section className='backgroung-image-profesional-domain'>
         <Navbar/>
         <div className='header-Careers-contents'>
            <h1>Delivered by Compliance</h1>
            <h2>Awareness Team</h2>
         </div>
      </section>
   </header>
   <main className="main">
      <section className='container about-success'>
         <div className='Testimonials-success-work'>
            {/* <!------what start--------> */}
            <div className="testimonials-bg">
               <div className="container">
                  <div className="row">
                     <h5>SERVICES</h5>
                     <h2><span>Professional </span> service domain</h2>
                  </div>
               </div>
            </div>
            {/* <!------success end--------> */}
         </div>
      </section>
      {/* program section start */}
      <section className='program-sections'>
         <div className="thisPracticess">
            <div className="container">
               <img src={DomianIMg} alt="ncnbdjcn"/>
            </div>
         </div>
      </section>
      {/* program section end */}
      {/* program form Inner start */}
      <section className='Program-form'>
       <LeaderForm/>
      </section>
      {/* program form end */}
      {/* Happy Clients Start */}
      <section className='Happy-clients'>
         <HappyClients/>
      </section>
      {/* Happy Clients END */}
      {/* Brand Section Start */}
      <BottomCarousel/>
      {/* Brand Section end */}
   </main>
   {/* <!------footer start--------> */}
   <Footer/>
   {/* <!------footer end--------> */}
</div>
);
}
export default ProfessionalService;